import { useState } from "react";
import { motion } from "framer-motion";
import { Users, UserSquare2, UserCog, Star, Video } from "lucide-react";
import DriveArtists from "./DriveArtists";
import DriveCustomers from "./DriveCustomers";
import DriveExternals from "./DriveExternals";
import DriveFeatures from "./DriveFeatures";
import DriveCreators from "./DriveCreators";

export default function DriveCRM() {
  const [tab, setTab] = useState("artists");

  return (
    <div className="space-y-6">
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <div className="flex items-center gap-3 mb-3 text-[10px] tracking-[0.4em] uppercase text-zinc-500 font-bold">
          <span className="block w-8 h-px bg-[#ff0033] shadow-[0_0_8px_#ff0033]" />
          CRM & Kontakte
        </div>
        <h1 className="font-display font-black uppercase tracking-tighter leading-none text-3xl md:text-5xl">Alle Kontakte</h1>
        <p className="mt-3 text-sm text-zinc-500 max-w-2xl">
          Verwalte Künstler, Kunden und externe Kontakte (z.B. Familie, Berater für NDAs) zentral.
        </p>
      </motion.div>

      <div className="flex items-center gap-1 border-b border-white/[0.06] flex-wrap">
        <TabBtn active={tab === "artists"} onClick={() => setTab("artists")} icon={Users} testid="crm-tab-artists">Künstler</TabBtn>
        <TabBtn active={tab === "features"} onClick={() => setTab("features")} icon={Star} testid="crm-tab-features">Feature-Künstler</TabBtn>
        <TabBtn active={tab === "creators"} onClick={() => setTab("creators")} icon={Video} testid="crm-tab-creators">Creator</TabBtn>
        <TabBtn active={tab === "customers"} onClick={() => setTab("customers")} icon={UserSquare2} testid="crm-tab-customers">Kunden</TabBtn>
        <TabBtn active={tab === "externals"} onClick={() => setTab("externals")} icon={UserCog} testid="crm-tab-externals">Externe</TabBtn>
      </div>

      <div className="pt-2">
        {tab === "artists" && <DriveArtists embedded />}
        {tab === "features" && <DriveFeatures embedded />}
        {tab === "creators" && <DriveCreators embedded />}
        {tab === "customers" && <DriveCustomers embedded />}
        {tab === "externals" && <DriveExternals embedded />}
      </div>
    </div>
  );
}

const TabBtn = ({ active, onClick, icon: Icon, testid, children }) => (
  <button
    onClick={onClick}
    data-testid={testid}
    className={`flex items-center gap-2 px-5 py-3 text-[11px] font-bold tracking-[0.25em] uppercase transition-colors border-b-2 -mb-px ${
      active ? "border-[#ff0033] text-white" : "border-transparent text-zinc-500 hover:text-white"
    }`}
  >
    <Icon size={13} /> {children}
  </button>
);
